/**
 * Quick View - Shared fallback implementation
 *
 * Provides a safe global `window.openQuickView(url)` so inline handlers don't throw and
 * Quick View works even when section inline scripts are not executed in some dev setups.
 *
 * Also dispatches `quickViewContentLoaded` after injection so shared components (e.g.
 * product gallery modal) can observe/re-init.
 */
(function () {
  'use strict';

  if (window.openQuickView) return;

  function closeQuickView(modal) {
    if (!modal) return;
    try {
      modal.parentNode && modal.parentNode.removeChild(modal);
    } catch (e) {}
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function getI18nSource() {
    return (
      document.querySelector('.collection-page') ||
      document.querySelector('[data-i18n-close-quick-view]') ||
      document.body
    );
  }

  function getI18nLabels() {
    var src = getI18nSource();
    var ds = (src && src.dataset) ? src.dataset : {};
    return {
      closeLabel: (ds.i18nCloseQuickView || ds.i18nClose || 'Close'),
      viewLabel: (ds.i18nViewFullDetails || ''),
    };
  }

  window.openQuickView = function (productUrl) {
    try {
      if (!productUrl) return;

      var quickViewUrl = productUrl.indexOf('?') >= 0
        ? productUrl + '&view=quick-view'
        : productUrl + '?view=quick-view';

      fetch(quickViewUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var root =
            doc.querySelector('.product-quick-view') ||
            doc.querySelector('[data-section-type="product-quick-view"]') ||
            doc.querySelector('[id*="shopify-section-product-quick-view"]') ||
            doc.querySelector('main') ||
            doc.body;

          var productContent = root ? root.innerHTML : html;
          var labels = getI18nLabels();

          var modal = document.createElement('div');
          modal.className = 'quick-view-modal';

          var overlay = document.createElement('div');
          overlay.className = 'quick-view-modal__overlay';

          var content = document.createElement('div');
          content.className = 'quick-view-modal__content';

          var closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'quick-view-modal__close';
          closeBtn.setAttribute('aria-label', labels.closeLabel);
          closeBtn.innerHTML = '&times;';

          var body = document.createElement('div');
          body.className = 'quick-view-modal__body';
          body.innerHTML = productContent;

          var footer = document.createElement('div');
          footer.className = 'quick-view-modal__footer';

          var viewFull = document.createElement('a');
          viewFull.href = productUrl;
          viewFull.className = 'quick-view-modal__view-full';
          viewFull.textContent = labels.viewLabel || productUrl;

          footer.appendChild(viewFull);
          content.appendChild(closeBtn);
          content.appendChild(body);
          content.appendChild(footer);
          modal.appendChild(overlay);
          modal.appendChild(content);

          document.body.appendChild(modal);
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';

          // Let shared logic know quick view content has been injected.
          try {
            document.dispatchEvent(new CustomEvent('quickViewContentLoaded'));
          } catch (e) {}

          overlay.addEventListener('click', function () { closeQuickView(modal); });
          closeBtn.addEventListener('click', function () { closeQuickView(modal); });

          document.addEventListener('keydown', function onKey(e) {
            if (e.key === 'Escape') {
              document.removeEventListener('keydown', onKey);
              closeQuickView(modal);
            }
          });
        })
        .catch(function () {
          window.location.href = productUrl;
        });
    } catch (e) {
      window.location.href = productUrl;
    }
  };

  // Ensure legacy inline handlers that call `openQuickView(...)` (without `window.`) still work.
  // In non-module scripts, assigning to an undeclared identifier creates a global variable.
  // `typeof` is safe even when the identifier doesn't exist.
  if (typeof openQuickView === 'undefined') {
    // eslint-disable-next-line no-undef
    openQuickView = window.openQuickView;
  }
})();


